import onResize from '../utils/onResize'

export default {
  name: 'horizontal-slide',

  ui: {
    content: '[js-horizontal-slide-content]',
  },

  isDown: false,

  events: [
    {
      on: 'mousedown',
      handle (e) {
        this.isDown = true
        this.startX = e.pageX - this.el.offsetLeft
        this.scrollLeft = this.el.scrollLeft
      },
    },
    {
      on: 'mouseleave',
      handle (e) {
        this.isDown = false
      },
    },
    {
      on: 'mouseup',
      handle (e) {
        this.isDown = false
      },
    },
    {
      on: 'mousemove',
      handle (e) {
        if (!this.isDown) return
        const x = e.pageX - this.el.offsetLeft
        const walk = (x - this.startX)
        this.el.scrollLeft = this.scrollLeft - walk

        if (this.ui.content.scrollWidth - this.el.scrollLeft - this.el.offsetWidth <= 0) {
          this.el.parentNode.classList.remove('is-scrollable')
        } else {
          this.el.parentNode.classList.add('is-scrollable')
        }
      },
    },
    {
      on: 'touchmove',
      handle (e) {
        if (this.ui.content.scrollWidth - this.el.scrollLeft - this.el.offsetWidth <= 0) {
          this.el.parentNode.classList.remove('is-scrollable')
        } else {
          this.el.parentNode.classList.add('is-scrollable')
        }
      },
    },
  ],

  componentDidMount () {
    this.off = onResize(this.onResize.bind(this))

    this.onResize()
  },

  componentWillUnmount () {
    this.off()
  },

  onResize () {
    this.checkIfBigger()
  },

  checkIfBigger () {
    if (this.el.offsetWidth < this.ui.content.scrollWidth) {
      this.el.parentNode.classList.add('is-scrollable')
    } else {
      this.el.parentNode.classList.remove('is-scrollable')
    }
  },
}
